import { NavController, NavParams, App, ModalController, ViewController, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Component, OnInit, Input } from '@angular/core';

import { AuthProvider } from '../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../providers/employeerh/employeerh';


@Component({
  selector: 'page-rh-offboarding',
  templateUrl: 'rh-offboarding.html',
})
export class RhOffboardingPage implements OnInit {

  offboarding:any = null;
  questions: any = [
    'Intérêt des missions',
    'Relations collègues',
    'Relations clients',
    'Suivi managérial',
    'Suivi de carrière',
    'Encadrement/Accompagnement',
    'Organisation du travail',
    'Charge de travail raisonnable',
    'Communication interne',
    'Outils de travail',
    'Equilibre vie pro/vie perso',
    'Rémunération',
    'Environnement de travail'
  ];

  answers:any = {
      offboarding_id: null,
      question : null,
      questionMail : null,
      booleanQuestions : []
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storageProvider: Storage,
    public app: App,
    public authProvider: AuthProvider,
    public employeeRhProvider: EmployeeRhProvider,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController
  ) {
  }

  ngOnInit() {
        this.loadDatas();
  }

  loadDatas() {
    this.employeeRhProvider.getOffboardingQuestions().subscribe((res) => {
        if(res.success){
            this.offboarding = res.data;
            this.answers.offboarding_id = res.data.id;
            this.offboarding.content = res.data.content.replace(/\r?\n|\r/g, '<br/>');
        }
    })
  }

  setAnswer(index, value){
      this.answers.booleanQuestions.push({id : index, value : value});
      this.questions.splice(index, 1)
  }

  submitAnswer(){
      if(this.answers.question == null || this.answers.questionMail == null){
        let toast = this.toastCtrl.create({ message: "Merci de répondre à toutes les questions", duration: 6000, position: 'top'});
        toast.present();
        return;
      }else{
          this.employeeRhProvider.offboardingSubmitAnswer(this.answers).subscribe((res) => {
              if(res.success){
                let toast = this.toastCtrl.create({ message: "Vos réponses ont été envoyées", duration: 6000, position: 'top'});
                toast.present();
                this.dismiss()
              }
          })
      }
  }


   
// Modal ctrl
dismiss() {
    this.viewCtrl.dismiss();
}


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-offboarding/rh-offboarding.ts